import React from 'react';
import { Hero } from './components/Hero';
import { Historia } from './components/Historia';
import { Proceso } from './components/Proceso';
import { Productos } from './components/Productos';
import { Porque } from './components/Porque';
import { Visitanos } from './components/Visitanos';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-crema text-negro font-labrada" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Historia data-id="element-3" />
        <Proceso data-id="element-4" />
        <Productos data-id="element-5" />
        <Porque data-id="element-6" />
        <Visitanos data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}